import NavBar from './NavBar'
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import rehypeRaw from 'rehype-raw'
import { useEffect, useState } from 'react'

function AccountDeletionFaq() {
  const [mdContent, setMdContent] = useState('')
  useEffect(() => {
    fetch('/accountDeletionFaq.md')
      .then((response) => response.text())
      .then((text) => {
        setMdContent(text)
      })
  },[])
  return (
    <>
      <NavBar />
      <div className="markdown-body mx-8 my-2 lg:mx-80 lg:my-20">
        <h1 className="mb-4 text-center text-[24px] font-extrabold lg:text-[48px]">
          Account Deletion FAQ
        </h1>
        <Markdown 
            rehypePlugins={[rehypeRaw]} 
            remarkPlugins={[remarkGfm]}
            components={{
            a: ({node, children, ...props}) => (
                <a {...props} className="text-blue-600 hover:text-blue-800 underline" target="_blank" rel="noopener noreferrer">
                {children}
                </a>
            )
            }}
        >
          {mdContent}
        </Markdown>
      </div>
    </>
  )
}

export default AccountDeletionFaq
